export const CommentsColumns = [
    {
        name: 'Номер заказа/накладной',
        key: 'number',
    },
    {
        name: 'Дата отправки коммента',
        key: 'sentAt',
    },
    {
        name: 'Комментарий',
        key: 'comment',
    },
    {
        name: 'Пользователь',
        key: 'createdByEmail',
    },
]
